import { CSSObjectWithLabel, StylesConfig } from "react-select";

import { greyMui, rydeColors, ScreenDepth } from "@ryde/theme";

import { FILTER_CONST } from "./filter-multiselect-models";

export const selectStyles: StylesConfig<unknown, true> = {
  control: provided =>
    ({
      ...provided,
      position: "absolute",
      width: FILTER_CONST.DROPDOWN_AREA_WIDTH,
      top: FILTER_CONST.SEARCH_CONTROL_TOP,
      height: FILTER_CONST.SEARCH_CONTROL_HEIGHT,
      zIndex: ScreenDepth.HEADER_FORM_CONTROLS,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      paddingInlineStart: 10,
      outline: "none",
      ":hover": {
        border: "none",
      },
      ":active": {
        backgroundColor: greyMui._500,
      },
    }) as CSSObjectWithLabel,
  menu: provided =>
    ({
      ...provided,
      backgroundColor: rydeColors.white,
      borderRadius: 4,
      position: "absolute",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      zIndex: ScreenDepth.HEADER_FORM_CONTROLS,
      margin: 0,
      top: FILTER_CONST.SCROLLABLE_AREA_TOP_OFFSET,
      width: FILTER_CONST.DROPDOWN_AREA_WIDTH,
    }) as CSSObjectWithLabel,
  menuList: provided =>
    ({
      ...provided,
      padding: 0,
    }) as CSSObjectWithLabel,
  option: provided =>
    ({
      ...provided,
    }) as CSSObjectWithLabel,
};
